import { withTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import styled from "styled-components";

// Components
import Text from "components/Text";
import Title from "components/Title";
import IkomMountQuotationsModal from "components/IkomMountQuotationsModal";

// Redux
import { setGlobalSelectedMount, toggleModalEffectCreation, setQuotationBasket, setMountQuotations } from "modules/ui/actions";

// Utils
import { post, get } from "library/endpoints";

// Styled
const ImageWrapper = styled.div`
  text-align: center;
  background: black;
  height: 140px;
  margin: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 0 5px grey;
  border-radius: 10px;
  position: relative;
  cursor: pointer;

  > image {
    width: 90%;
  }
`;

/**
 * MountQuotations
 * @param {*} props 
 * @returns 
 */
const MountQuotations = (props) => {
  const [displayModal, setDisplayModal] = useState(false);
  const [selectedMount, setSelectedMount] = useState(null);

  useEffect(() => { 
    if (!props.auth.token) {
      props.push('/')
    }
    fetchMountQuotations();
  }, []) // eslint-disable-line

  const fetchMountQuotations = async () => {
    try {
      const response = await get(`/frontend/mount-quotations`);
      props.setMountQuotations(response.data);
    } catch (error) {
      console.log(error)
    }
  }

  const handleOnDownload = (url) => {
    window.open(url);
  }
  
  const handleOnAccept = async (mount) => {
    try {
      await post(`/frontend/mount-quotations/accept/${mount._id}`)
      setDisplayModal(false)
      setSelectedMount(null)
      fetchMountQuotations()
    } catch (error) {
      console.log(error)
    }
  }

  const handleOnRefuse = async (mount) => {
    try {
      await post(`/frontend/mount-quotations/refuse/${mount._id}`)
      setDisplayModal(false)
      setSelectedMount(null)
      fetchMountQuotations()
    } catch (error) {
      console.log(error)
    }
  }

  console.log(props.ui.mountQuotations)

  return (
    <>
      {
        props.ui.quotationBasket.length > 0 && (
          <div style={{ width: '100%', background: '#53b297', padding: 10, cursor: 'pointer' }} onClick={() => props.push(`/quotations`)}>
            <Text color="white" align="center" underline>Un devis vous a été envoyé par votre boutique, cliquez ici pour le consulter</Text>
          </div>
        )
      }

      {
        displayModal && (
          <IkomMountQuotationsModal 
            mount={selectedMount} 
            handleOnClose={() => setDisplayModal(false)}
            handleOnDownload={handleOnDownload}
            handleOnAccept={handleOnAccept}
            handleOnRefuse={handleOnRefuse}
          />
        )
      }

      <div
        style={{ width: '100%',  }}
      >
        <Title align="center" style={{ paddingTop: 20, marginBottom: 20 }}>Vos propositions de montage</Title>       

        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', marginBottom: 10 }}>

          {
            props.ui.mountQuotations.map((mount) => (
              <ImageWrapper>
                <img 
                  src={`${process.env.REACT_APP_S3_FILES_URL}${mount.output}`} 
                  style={{ width: 125 }} 
                  onClick={() => { setSelectedMount(mount); setDisplayModal(true); }} alt={`Votre montage`}
                />
              </ImageWrapper>
            ))
          }

          {
            props.ui.mountQuotations.length === 0 && (
              <Text color="black" size={14} align="center" style={{ paddingTop: 20, marginBottom: 20 }}>Aucune proposition pour le moment</Text>       
            )
          }
        </div>
      </div>
    </>
  )
}

const stateToProps = state => ({
  auth: state.auth,
  ui: state.ui
})

const dispatchToProps = {
  push,
  setGlobalSelectedMount,
  toggleModalEffectCreation,
  setQuotationBasket,
  setMountQuotations
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(MountQuotations))